import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import VideoThumbnail from "react-video-thumbnail";
// import { generateImageUrl } from "../../../utils/cloudinaryUtil";
import { useS3Upload } from "../../../hooks/useS3Upload";

export default function ImageSource({ photo }) {
  const [imageSource, setImageSource] = useState();
  const [thumbnailImage, setThumbnailImage] = useState();
  const { getSeekerMedia } = useS3Upload();
  const getS3URL = useCallback(
    async (key) => {
      if (key) {
        const url = await getSeekerMedia(key);
        setImageSource(url);
      }
    },
    [getSeekerMedia]
  );

  useEffect(() => {
    if (photo?.photo) {
      getS3URL(photo.photo[0]);
    }
    if (photo?.video) {
      getS3URL(photo.video);
    }
  }, [getS3URL, photo]);

  // useEffect(() => {
  //   if (photo?.photo) {
  //     setImageSource(generateImageUrl(photo?.photo[0]));
  //   }
  //   if (photo?.video) {
  //     setImageSource(photo?.video.replace(".mp4", ".jpg"));
  //   }
  // }, []);

  if (photo?.video && imageSource && !thumbnailImage) {
    return (
      <Portal>
        <VideoThumbnail
          videoUrl={imageSource}
          thumbnailHandler={(thumbnail) => {
            setThumbnailImage(thumbnail);
          }}
          snapshotAtTime={1}
        />
      </Portal>
    );
  }

  if (imageSource || thumbnailImage) {
    return (
      <image
        className="step-image"
        x="0%"
        y="0%"
        width="1"
        height="1"
        href={thumbnailImage || imageSource}
        preserveAspectRatio="xMidYMid slice"
        s
      ></image>
    );
  } else {
    return null;
  }
}

export const Portal = (props) => {
  const el = useRef(document.createElement("div"));
  useEffect(() => {
    const portal = document.getElementById("portal");
    portal.appendChild(el.current);

    return () => {
      portal.removeChild(el.current);
    };
  }, [props.children]);

  return ReactDOM.createPortal(props.children, el.current);
};

export const PortalDiv = () => <div id="portal"></div>;
